import React, { Component } from 'react';
import {
    Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';

// Navigation Bar Class
export class NavigationBar extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
        };
    }

    // toggle Navbar
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        return (

            // navigation bar
            <div>
                <Navbar className="fixed" color="light" light expand="lg">
                    <NavbarBrand tag={Link} to="/" className="kurb-bd">
                        <img src="../img/event.png" className="d-inline-block align-top" alt="SpeNeeds logo" />SpeNeeds
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="mr-auto mt-2 mt-lg-0 kurb-med" navbar>
                            <NavItem>
                                <NavLink tag={Link} to="/" activeClassName="active" exact>Home</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="/browse" activeClassName="active">Programs &amp; Events</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="/aboutUs" activeClassName="active">About Us</NavLink>
                            </NavItem>
                        </Nav>
                        <DropDown logInMember={this.props.logInMember} user={this.props.user} logInOrg={this.props.logInOrg} memberSignIn={this.props.memberSignIn} orgSignIn={this.props.orgSignIn} logOut={this.props.logOut} />
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}

export class DropDown extends Component {

    render() {
        let dropdownItem = null;

        // dropdown item names for different types of users 
        if (this.props.logInMember) {
            dropdownItem = [
                ['My Page', 'link', "myPage"],
                ['divider'],
                ['logOut', 'Log Out']
            ];
        } else if (this.props.logInOrg) {
            dropdownItem = [
                ['My Page', 'link', "myOrgPage"],
                ['divider'],
                ['logOut', 'Log Out']
            ];
        } else {
            dropdownItem = [
                ['memClick', 'Sign In as Member'],
                ['orgClick', 'Sign In as Organization']
            ];
        }

        // dropdown items placement
        let items = dropdownItem.map((item, index) => {
            if (item[0] === 'divider') {
                return <DropdownItem key={index} divider />;
            } else if (item[0] === 'memClick') {
                return <DropdownItem tag={Link} key={index} to="/" activeStyle={{ textDecoration: 'none', color: 'black' }} onClick={this.props.memberSignIn}>{item[1]}</DropdownItem>;
            } else if (item[0] === 'orgClick') {
                return <DropdownItem tag={Link} key={index} to="/" activeStyle={{ textDecoration: 'none', color: 'black' }} onClick={this.props.orgSignIn}>{item[1]}</DropdownItem>;
            } else if (item[0] === 'logOut') {
                return <DropdownItem tag={Link} key={index} to="/" activeStyle={{ textDecoration: 'none', color: 'black' }} onClick={this.props.logOut}>{item[1]}</DropdownItem>;
            } else if (item[1] === 'link') {
                let link = "/" + item[2];
                return <DropdownItem tag={Link} key={index} to={link}>{item[0]}</DropdownItem>;
            } else {
                return <DropdownItem key={index}>{item[0]}</DropdownItem>;
            }
        });

        // log in members and organizations' display names
        let toggleDropdown;
        if (this.props.logInMember) {
            toggleDropdown = <DropdownToggle nav caret><img src="../img/sign-up.png" className="d-inline-block align-top mr-1" alt="signed in" />{this.props.user.displayName}</DropdownToggle>;
        } else if (this.props.logInOrg) {
            toggleDropdown = <DropdownToggle nav caret><img src="../img/sign-up.png" className="d-inline-block align-top mr-1" alt="signed in" />{this.props.user.displayName}</DropdownToggle>;
        } else {
            toggleDropdown = <DropdownToggle nav caret> Sign In </DropdownToggle>;
        }

        return (
            <Nav className="right mt-2 mt-lg-0 kurb-med" navbar>
                <UncontrolledDropdown nav inNavbar>
                    {toggleDropdown}
                    <DropdownMenu right>
                        {items}
                    </DropdownMenu>
                </UncontrolledDropdown>
            </Nav>
        );
    }
}